export {}

export interface Community {
    name: string ;
    address: string;
    latitude: number;
    longitude: number;
  }
  
export const communityData: Community[] = [
    {   
        "name":"Migrants Community",
        "address":"Barbaza, Antique", 
        "latitude": 11.2231318,
        "longitude": 122.0541271
    },
    {
        "name":"Pantad Ati",
        "address":"Tobias Fornier, Antique",
        "latitude": 10.5165,
        "longitude": 121.9995
    },
    {
        "name":"CAARD Partner Communities - Sto. Tomas",
        "address":"Passi City, Iloilo",
        "latitude": 11.203971,
        "longitude": 122.644725
    },
    {
        "name":"CAARD Partner Communities - Salngan",
        "address":"Passi City, Iloilo",
        "latitude": 11.190288,
        "longitude": 122.726746
    },
    {
        "name":"Yolanda Pabahay",
        "address":"Estancia, Iloilo",
        "latitude": 11.4619823,
        "longitude": 123.1463992
    },
    {
        "name":"Kati-Kati Ati",
        "address":"Jordan, Guimaras",
        "latitude": 10.580377,
        "longitude": 122.592247
    },
    {
        "name":"Camang-camang Ati Cultural Community",
        "address":"Marikudo, Isabela, Negros Occidental",
        "latitude": 10.2043253,
        "longitude": 122.9878393
    },
    {
        "name":"Lanit Ati Village",
        "address":"Jaro, Iloilo City",
        "latitude": 10.7503937,
        "longitude": 122.5701037
    },
    {
        "name":"Dacal Ati",
        "address":"San Enrique, Iloilo",
        "latitude": 11.1098942,
        "longitude": 122.7294309
    },
    {
        "name":"NAMIAS Ati - Barotac Viejo",
        "address":"Barotac Viejo, Iloilo",
        "latitude": 11.0625316,
        "longitude": 122.8761309
    },
    {
        "name":"Caridad - Hamtic Community",
        "address":"Hamtic, Antique",
        "latitude": 10.691799,
        "longitude": 121.989919
    },
    {
        "name":"Poblacion 4 - Hamtic Community",
        "address":"Hamtic, Antique",
        "latitude": 10.701997,
        "longitude": 121.985804
    },
    {
        "name":"NAMIAS Ati - Anilao",
        "address":"Anilao, Iloilo",
        "latitude": 11.0002604,
        "longitude": 122.740723
    },
    {
        "name":"Mt. Tagao Ati",
        "address":"Dumarao, Capiz",
        "latitude": 11.2421989,
        "longitude": 122.695547
    },
    {
        "name":"NAMIAS Ati - Batad",
        "address":"Batad, Iloilo",
        "latitude": 11.4169972,
        "longitude": 123.1126559
    },
    {
        "name":"Kabangrusan Ati",
        "address":"Nabas, Aklan",
        "latitude": 11.8517124,
        "longitude": 122.026918
    },
    {
        "name":"Malay Ati Tribal Association (MATA)",
        "address":"Malay, Aklan",
        "latitude": 11.9003045,
        "longitude": 121.958687
    }
]